export default "__VITE_ASSET__20752023__"